import React from 'react';

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <p className="copyright">&copy; {new Date().getFullYear()} CARY ZHU. ALL RIGHTS RESERVED.</p>
            </div>
        </footer>
    );
};

export default Footer;